import usePing from "@/domains/hud/hooks/usePing";
import HudPing from "@/domains/hud/components/HudPing";

export default function HudPingContainer() {
  const { latency } = usePing();

  return <HudPing latency={latency} />;
}
